import { ApolloCache, gql } from '@apollo/client';
import { achievementFragment } from '../fragments/achievement';
import { categoryFragment } from '../fragments/category';
import {
    CreateAchievementMutation,
    GetCategoryAchievementsQuery,
    GetCategoryAchievementsQueryVariables,
    GetTemplateAchievementsQuery,
} from '../generated/graphql';
import { getCategoryAchievements } from '../queries/achievement';
import { getTemplateAchievementsQuery } from '../queries/templateAchievements';

export const createAchievementMutation = gql`
    ${achievementFragment}
    ${categoryFragment}

    mutation CreateAchievement(
        $name: String!
        $description: String!
        $categoryId: String!
        $achievementConditions: [AchievementConditionCreateInput!]!
        $icon: String
        $rarity: AchievementRarity!
        $templateId: String
        $iconImageColor: String
        $iconImageUrl: String
        $iconImageUrlNotAchieved: String
    ) {
        createAchievement(
            data: {
                name: $name
                description: $description
                categoryId: $categoryId
                achievementConditions: $achievementConditions
                icon: $icon
                rarity: $rarity
                templateId: $templateId
                iconImageColor: $iconImageColor
                iconImageUrl: $iconImageUrl
                iconImageUrlNotAchieved: $iconImageUrlNotAchieved
            }
        ) {
            ...AchievementFields
            category {
                ...CategoryFields
            }
        }
    }
`;

export function createAchievementCache(cache: ApolloCache<any>, { data }: { data?: CreateAchievementMutation | null }) {
    if (!data?.createAchievement) return;

    const achievement = data.createAchievement;
    const categoryId = achievement.categoryId;

    const categoryData = cache.readQuery<GetCategoryAchievementsQuery, GetCategoryAchievementsQueryVariables>({
        query: getCategoryAchievements,
        variables: { categoryId },
    });
    if (categoryData) {
        const newCategoryAchievements = [...categoryData.achievements, achievement];
        cache.writeQuery<GetCategoryAchievementsQuery, GetCategoryAchievementsQueryVariables>({
            query: getCategoryAchievements,
            variables: { categoryId },
            data: { ...categoryData, achievements: newCategoryAchievements },
        });
    }

    if (achievement.templateId) {
        const templateData = cache.readQuery<GetTemplateAchievementsQuery>({ query: getTemplateAchievementsQuery });
        if (templateData && !templateData.achievements.some(a => a.id === achievement.id)) {
            cache.writeQuery<GetTemplateAchievementsQuery>({
                query: getTemplateAchievementsQuery,
                data: {
                    ...templateData,
                    achievements: [
                        ...templateData.achievements,
                        {
                            id: achievement.id,
                            templateId: achievement.templateId,
                            questIds: achievement.questIds,
                            achievementConditions: achievement.achievementConditions,
                        },
                    ],
                },
            });
        }
    }
}
